import PropTypes from "prop-types"
import { Card } from "@mui/material"
import { INSTRUMENT_SIZE_SHAPE } from "modules/smart-trade-panel/helpers"
import EnhancedTable from "./components/EnhancedTable"
import LoadingWrapper from "components/loading-wrapper"
import Loading from "../loading"
import Error from "../error"

import "./styles.scss"

export default function Summary({ securities = [], removeSecurities, status, isReadOnly, refSecurities = [], dispatch, instrumentPortfolio, instrumentSize, isSegment, openSecurityProfile2 }) {
  const loadingComponent = <Loading />
  const errorComponent = <Error text="An error occured while performing the smart trade, please change the rules and try again." />

  return <Card square className="components_smart-trade-panel-positions">
    <LoadingWrapper status={status} loadingComponent={loadingComponent} errorComponent={errorComponent}>
      <EnhancedTable items={securities} isReadOnly={isReadOnly} refSecurities={refSecurities} removeSecurities={removeSecurities} dispatch={dispatch} instrumentPortfolio={instrumentPortfolio} instrumentSize={instrumentSize} isSegment={isSegment} openSecurityProfile2={openSecurityProfile2} />
    </LoadingWrapper>
  </Card>
}

Summary.propTypes = {
  securities: PropTypes.array.isRequired,
  refSecurities: PropTypes.array.isRequired,
  status: PropTypes.array.isRequired,
  removeSecurities: PropTypes.func.isRequired,
  applyButtonEnabled: PropTypes.bool.isRequired,
  onApply: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  instrumentPortfolio: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  instrumentSize: INSTRUMENT_SIZE_SHAPE.isRequired,
  isSegment: PropTypes.bool.isRequired,
  openSecurityProfile2: PropTypes.func.isRequired,
}
